import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { Pagination } from '../models/pagination';
import { MojoTasksService, Task, TasksEntityType, TotalTaskCountDashboard } from 'mojo-tasks';

@Injectable({
  providedIn: 'root',
})
export class TasksService extends ApiService implements MojoTasksService {
  constructor() {
    super();
    this.url = 'task/';
  }

  getMojoTasks(
    entityType: TasksEntityType,
    entityId: string,
    page?: number,
    size: number = 0,
    hasAnonymization?: boolean,
  ): Observable<Pagination<Task>> {
    const sizeToSend = size > 0 ? size : 10;
    return this.get({
      url: `${entityType}/${entityId}`,
      params: {
        page,
        size: sizeToSend,
        anonymization: hasAnonymization,
        sort: 'lastModifiedDate',
        sortDir: 'sort.dir',
        onlyMyTasks: false,
      },
    });
  }

  createTask(task: Partial<Task>, entityType?: string, entityId?: string): Observable<Task> {
    return this.post({
      url: entityType && entityId ? `${entityType}/${entityId}` : '',
      body: task,
      params: { assignedUser: task.assignedUser },
    });
  }

  patchTask(task: Partial<Task>): Observable<Task> {
    return this.patch({
      url: `${task.id}`,
      body: task,
      params: { assignedUser: task.assignedUserId?.toString() },
    });
  }

  completeTask(taskId: number): Observable<void> {
    return this.post({ url: `${taskId}?complete` });
  }

  removeTask(taskId: number): Observable<Task> {
    return this.post({ url: `${taskId}?remove` });
  }

  getDashboardPage(
    group: 'overdue' | 'today' | 'upcoming',
    page: number,
    size: number,
  ): Observable<Pagination<Task>> {
    return this.get({
      url: `dashboard`,
      params: { group, page, size },
    });
  }

  getTotalTaskCountDashboard?(): Observable<TotalTaskCountDashboard> {
    return this.get({ url: 'dashboard-count' });
  }
}
